import { render } from "./websiteBooks.vue?vue&type=template&id=86b16a56&scoped=true"
import script from "./websiteBooks.vue?vue&type=script&lang=js"
export * from "./websiteBooks.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./websiteBooks.vue?vue&type=style&index=1&id=86b16a56&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86b16a56"]])

export default __exports__